/**
 * Theme utility functions for common styling patterns
 */

import { primitiveColors } from './tokens';

/**
 * Creates a gradient-border background using the padding-box/border-box trick.
 * Used for CTA buttons with gradient borders.
 */
export const gradientBorderBackground = (innerColor: string, gradient: string) =>
  `linear-gradient(${innerColor}, ${innerColor}) padding-box, ${gradient} border-box`;

/**
 * Creates the brand gradient with a dynamic opacity hex suffix.
 * Used for loading states where the gradient is partially transparent.
 */
export const getBrandGradientWithOpacity = (opacityHex: string) =>
  `linear-gradient(90deg, ${primitiveColors.blue3}${opacityHex} 0%, ${primitiveColors.purple1}${opacityHex} 50%, ${primitiveColors.red1}${opacityHex} 100%)`;
